/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Fair_Shy_Wren_MarchInputs */

const en_fair_shy_wren_march = /** @type {(inputs: Fair_Shy_Wren_MarchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
};

const de_fair_shy_wren_march = /** @type {(inputs: Fair_Shy_Wren_MarchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} weitere`)
};

/**
* | output |
* | --- |
* | "+{count} more" |
*
* @param {Fair_Shy_Wren_MarchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_shy_wren_march = /** @type {((inputs: Fair_Shy_Wren_MarchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Shy_Wren_MarchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_shy_wren_march(inputs)
	return de_fair_shy_wren_march(inputs)
});